import React from "preact/compat";
import {h, Component} from 'preact'
import {connect} from 'react-redux'

import AsideTemplates from './AsideTemplates'
import AsideText from './AsideText'
import AsideGraphics from './AsideGraphics'
import AsideDesigns from './AsideDesigns'
import AsideRevisions from './AsideRevisions'
import AsideMyDesigns from './AsideMyDesigns'
import AsideQRCodes from './AsideQRCodes'
import AsideFavorites from './AsideFavorites'

import reduce from '../reducers'
import * as actions from '../actions'
import AppAsideNav from "./AppAsideNav";
import AsideColorPicker from "./AsideColorPicker";
import AsideVideoAdjusts from "./AsideVideoAdjusts";
import CollapseIcon from "./svg/CollapseIcon";
import store from "../store";
import Interactable from "../canvas/interactable";
import util from "../util";
import AsideWordArt from "./AsideWordArt";
import AsideAnimations from "./AsideAnimations";
import { DownOutlined } from "@ant-design/icons";
import AsidePagesOptions from "./AsidePagesOptions";

export default @connect(reduce, actions)
class AppAside extends Component {
  constructor() {
    super();

    this.onCollapseClick = this.onCollapseClick.bind(this);

    this.prevLeftMenuVisible = false;
    this.unsubscribe = store.subscribe(() => {
      if (this.prevLeftMenuVisible !== store.getState().isLeftMenuVisible) {
        util.nextTick(() => {
          Interactable.adjustSelectionBoxes();
        });
      }
      this.prevLeftMenuVisible = store.getState().isLeftMenuVisible;
    });
  }

  componentWillUnmount() {
    this.unsubscribe?.();
  }

  onCollapseClick() {
    store.dispatch(actions.setIsLeftMenuVisible(!store.getState().isLeftMenuVisible));
    store.dispatch(actions.setIsMOEditModal(false));
    util.nextTick(() => {
      Interactable.adjustSelectionBoxes();
    });
  }

  render(props, state) {

    return (
      <aside id="app-aside" className={`link 
      ${props.view === 'resize'
        ? 'main print'
        : props.view === 'color-picker'
          ? 'main color-picker'
          : props.view === 'pages'
            ? 'main pages'
            : 'main'}`}>
        {window.data.member.hasViewOnlyPermission && <div className={"view-only-blocker"}></div>}
        {props.withNav && !store.getState().isMobileVersion &&
          <AppAsideNav
            hasPdfPermission={props.hasPdfPermission}
            hasTemplatesPermission={props.hasTemplatesPermission}
            isVersionPreview={props.isVersionPreview}
            view={props.view}/>
        }
        <div className="content">
          {store.getState().isMobileVersion &&
            <div className="header-nav">
              {props.view === "templates" && <div className="view-name">Templates</div>}
              {(props.view === "text" || props.view.indexOf('text-') > -1) && <div className="view-name">Text</div>}
              {props.view === "graphics" && <div className="view-name">Graphics</div>}
              {props.view === "designs" && <div className="view-name">Designs</div>}
              {props.view === "revisions" && <div className="view-name">Revisions</div>}
              {props.view === "my-designs" && <div className="view-name">My Designs</div>}
              {props.view === "qr-codes" && <div className="view-name">QR Codes</div>}
              {props.view === "color-picker" && <div className="view-name">Fill</div>}
              {props.view === "favorites" && <div className="view-name">Favorites</div>}
              {props.view === "pages" && <div className="view-name">More</div>}
              <DownOutlined onClick={() => store.dispatch(actions.setIsMobileAside(false))}/>
            </div>
          }

          {props.view === 'templates' && <AsideTemplates
            designId={props.designId}
            templateId={props.templateId}
            hasChanges={props.hasChanges}
            isFreemium={props.isFreemium}
            isTemplate={props.isTemplate}
            templateView={props.templateView}
            promoDesignsLoading={props.promoDesignsLoading}
            designSize={props.designSize}
            templateGroups={props.templateGroups}
            templateFamilies={props.templateFamilies}
            selectedFamily={props.selectedFamily}
            selectedCollection={props.selectedCollection}
            selectedCategory={props.selectedCategory}
            setShowExitWarning={props.setShowExitWarning}
            locationId={props.locationId}
            isQRDesignMode={props.isQRDesignMode}
          />}
          {props.view === 'graphics' && <AsideGraphics
            uploadedImages={props.uploadedImages}
            setUploadedImages={props.setUploadedImages}
          />}
          {props.view === 'designs' && <AsideDesigns />}
          {props.view === 'revisions' && <AsideRevisions />}
          {props.view === 'my-designs' && <AsideMyDesigns />}
          {props.view === 'qr-codes' && <AsideQRCodes />}
          {props.view === 'favorites' && <AsideFavorites 
            uploadedImages={props.uploadedImages || []}
            setUploadedImages={props.setUploadedImages} />}
          {(props.view === 'text' || props.view.indexOf('text-') > -1) && <AsideText
            uploadedIcons={props.uploadedIcons}
            setUploadedIcons={props.setUploadedIcons}
          />}
          {props.view === 'color-picker' && <AsideColorPicker />}
          {props.view === 'video-adjusts' && <AsideVideoAdjusts />}
          {props.view === 'word-art' && <AsideWordArt />}
          {props.view === 'animations' && <AsideAnimations />}
          {props.view === 'pages' && <AsidePagesOptions />}
        </div>
        {!store.getState().isMobileVersion &&
          <div className={'collapse hint--right'} data-hint={store.getState().isLeftMenuVisible ? 'Hide' : 'Show'}
               onClick={this.onCollapseClick}><CollapseIcon opened={store.getState().isLeftMenuVisible}/></div>}
      </aside>
    )
  }
}
